import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.jsx';
import{} from '@material-ui/core';


//************ SECTIONS COMPONENTS *************//
import SectionA from './Sections/SectionA/SectionA.jsx';
import SectionB from './Sections/SectionB/SectionB.jsx';
import SectionC from './Sections/SectionC/SectionC.jsx';
import SectionD from './Sections/SectionD/SectionD.jsx';
import SectionE from './Sections/SectionE/SectionE.jsx';
import SectionC1 from './Sections/SectionC1/SectionC1.jsx';



class ServicesDesktop extends Component{

  state = {
    ready: false,
    visited:{
      sectionA: false,
      sectionB: false,
      sectionC: false,
      sectionD: false,
      sectionE: false,
      sectionF: false,
    }
  }

  componentDidMount(){
    this.setState({ready:true})
  }

  onInview = (event, item) => {
    let temp = {...this.state.visited};
    temp[item] = true;
    this.setState({visited:{...temp}})
  }

  render(){
  
    const {classes, content, sendToPage} = this.props;
    const {ready} = this.state;

    return(
      <div className={classes.root}>
        <SectionA ready={ready} content={content}/>
        {/* <SectionB content={content.sectionB} />
        <SectionC content={content.sectionC} sendToPage={sendToPage}/>
        <SectionD content={content.sectionD}/>
        <SectionC1 content={content.sectionC1}/>
        <SectionE content={content.sectionE}/> */}
      </div>
      
    )
  }
}

export default withStyles(styles)(ServicesDesktop);
